<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listservices" class="blue-grey-text text-darken-4 strong">Security Master</router-link>
        >
        <span>Add Recommendation</span>
      </section>
    </article>
    <h4>Add Recommendation</h4>
    <article class="row">
      <look-ahead id="ticker-admin-add-rec-lookahead"
                  name="Ticker"
                  size="s6"
                  watermark="MSFT or Microsoft"
                  :picks="instrumentPicks"
                  @searched="fetchInstruments"
                  @picked="handleInstrumentPick"
      />
      <autocomplete id="ticker-admin-add-rec-portfolio"
                    name="Search for Portfolio"
                    size="s6"
                    watermark="Rule Breakers or @RuleBreakersInclusion"
                    :picks="portfolioPicks"
                    @picked="payload.portfolio_id = Number($event.slice(1, $event.indexOf(' ')))"
                    v-if="portfolioPicks.length"
      />
    </article>
    <article class="row">
      <section class="input-field col s6">
        <input id="ticker-admin-add-rec-open-date"
               type="text" class="datepicker"
               @change="payload.open_date = $event.target.value"
        >
        <label class="active">Open Date</label>
      </section>
      <section class="input-field col s6">
        <input id="ticker-admin-add-rec-close-date"
               type="text" class="datepicker"
               @change="payload.close_date = $event.target.value"
        >
        <label class="active">
          Close Date
          <span class="grey-text text-lighten-1">(Optional)</span>
        </label>
      </section>
    </article>
    <article class="row">
      <autocomplete id="add-rec-advisor-autocomplete"
                    name="Advisor (optional)"
                    size="s6"
                    :picks="$store.getters.analystsAutocompleteData"
                    watermark="Name/Email"
                    :disabled="false"
                    @picked="payload.advisor_id = $event.slice($event.indexOf('#') + 1, $event.length)"
                    v-if="$store.getters.analystsAutocompleteData.length"
      />
      <section class="input-field col s6">
        <select id="ticker-admin-add-rec-teams" multiple v-model="payload.team_codes">
          <option v-for="team in teams" :key="team.abbreviation" :value="team.abbreviation">
            {{ team.abbreviation }} - {{ team.name }}
          </option>
        </select>
        <label class="active" for="ticker-admin-add-rec-teams">
          Teams
          <span class="grey-text text-lighten-1">(Optional)</span>
        </label>
      </section>
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn green waves-effect waves-light right"
               type="submit"
               value="Submit"
               @click.prevent="saveRecommendation"
        >
      </section>
    </article>
    <article id="add-rec-usm-temp-modal" class="modal">
      <section class="modal-content">
        <h4>What is the ticker's <span class="amber-text strong">Security Class</span>?</h4>
        <article class="security-class-wrapper" style="display: flex; justify-content: center;">
          <section class="left-align">
            <p v-for="securityClass of securityClasses" :key="securityClass.id">
              <label>
                <input name="security-class" type="radio" :value="securityClass.id" v-model="selectedSecurityClass">
                <span>{{ securityClass.name }}</span>
              </label>
            </p>
          </section>
        </article>
      </section>
      <section class="modal-footer">
        <a class="waves-effect waves-green teal accent-4 btn" @click="vet" :disabled="loading">
          <loader v-if="loading" />
          <span v-else>Add</span>
        </a>
        <a class="modal-close left grey lighten-1 btn">Cancel</a>
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';
import LookAhead from '@/components/LookAhead.vue';
import Autocomplete from '@/components/Autocomplete.vue';
import Loader from '@/components/Loader.vue';

const defaultPayload = {
  analyst_id: 0,
  instrument_id: 0,
  portfolio_id: 0,
  open_date: '',
  close_date: null,
  advisor_id: null,
  team_codes: [],
};

export default {
  name: 'TickerAdminAddRecommendation',
  components: { LookAhead, Autocomplete, Loader },
  data() {
    return {
      instruments: [],
      portfolios: [],
      teams: [],
      payload: { ...defaultPayload, team_codes: [] },
      selectedSecurityClass: 1,
      usmTempModal: null,
      securityClasses: [],
      loading: false,
    };
  },
  computed: {
    instrumentPicks() {
      return this.instruments.map(instrument => `#${instrument.InstrumentId} ${instrument.Exchange}:${instrument.Symbol} ${instrument.Name}`);
    },
    portfolioPicks() {
      return this.portfolios.filter(portfolio => portfolio.active).map(portfolio => `#${portfolio.id} ${portfolio.name} (${portfolio.slug})`);
    },
    portfolioSelected() {
      return this.portfolios.filter(portfolio => portfolio.id === this.payload.portfolio_id)[0];
    },
  },
  methods: {
    async fetchPortfolios() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolios/`);
      this.portfolios = data;
    },
    async fetchTeams() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/teams/`);
      this.teams = data;
      this.$nextTick(() => {
        this.materialize.FormSelect.init(document.getElementById('ticker-admin-add-rec-teams'), {});
      });
    },
    async fetchInstruments(query) {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/quotes/instruments/search/?q=${query}`);
      this.instruments = data.SearchResults;
    },
    async fetchParent(instrumentId) {
      const response = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/parent/${instrumentId}/`);
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}${response.data[0].details}`);
      return { ...response.data[0], ...data[0] };
    },
    async handleInstrumentPick(choice, htmlElem) {
      const instrumentId = Number(choice.slice(1, choice.indexOf(' ')));
      const parent = await this.fetchParent(instrumentId);
      this.payload.instrument_id = parent.id;
      if (!parent.synced_with_xpressfeed) {
        return this.usmTempModal.open();
      }
      if (parent.inactive_date) {
        return this.toast(`${choice} has been delisted in Fool IQ`, 'pink');
      }
    },
    async saveRecommendation() {
      this.payload.analyst_id = this.$auth.user.pk;
      if (!this.payload.instrument_id) {
        return this.toast('Please type in an instrument, hit "Enter", and select from the dropdown', 'pink');
      }
      if (!this.payload.portfolio_id) {
        return this.toast('Please type in a portfolio, then select from the dropdown', 'pink');
      }
      if (!this.payload.open_date) {
        return this.toast('Please populate an Open Date', 'pink');
      }
      if (this.payload.close_date && new Date(this.payload.close_date) > new Date()) {
        return this.toast('Cannot enter an Close Date in the future', 'pink');
      }
      if (this.payload.close_date && new Date(this.payload.close_date) < new Date(this.payload.open_date)) {
        return this.toast('Cannot enter a Close Date earlier than Open Date', 'pink');
      }
      if (this.payload.close_date === '') {
        this.payload.close_date = null;
      }
      if (new Date(this.payload.open_date) > new Date()) {
        if (this.portfolioSelected.embargo_recs_until_publish) {
          this.toast('You have entered an open date in the future. Your rec will be pending until its recommendation article is published. If this is intended you do not need to do anything', 'amber');
        } else {
          return this.toast('Cannot enter an Open Date in the future for this portfolio', 'pink');
        }
      }
      const { data } = await axios
        .post(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/recommendation/`, this.payload)
        .catch((error) => {
          if (error.response && error.response.status === 409) {
            // The Insights API endpoint returns a 409 status code when an open recommendation already exists for the instrument in the portfolio.
            return this.toast('Cannot add recommendation, as only one open recommendation can exist for an instrument in a real money portfolio.', 'pink');
          }
          return this.toast('Error adding recommendation. Reach out to #investing-tech-help for assistance.', 'pink');
        });
      const instrumentFilter = this.instruments.filter(inst => inst.InstrumentId === this.payload.instrument_id);
      const portfolioFilter = this.portfolios.filter(port => port.id === this.payload.portfolio_id);
      const instrument = instrumentFilter.length ? instrumentFilter[0] : {};
      const portfolio = portfolioFilter.length ? portfolioFilter[0] : {};
      const msg = `Saved ${instrument.Exchange}:${instrument.Symbol} ${instrument.Name} to ${portfolio.name} (${portfolio.slug})`;
      this.toast(msg, 'green');
      this.payload = { ...defaultPayload, team_codes: [] };
      document.getElementById('ticker-admin-add-rec-lookahead').value = '';
      document.getElementById('ticker-admin-add-rec-portfolio').value = '';
      document.getElementById('ticker-admin-add-rec-open-date').value = '';
      document.getElementById('ticker-admin-add-rec-close-date').value = '';
      document.getElementById('add-rec-advisor-autocomplete').value = '';
      this.$nextTick(() => {
        this.materialize.FormSelect.init(document.getElementById('ticker-admin-add-rec-teams'), {});
      });
    },
    initDatepicker() {
      this.materialize.Datepicker.init(document.querySelectorAll('.datepicker'), {
        autoClose: false,
        format: 'yyyy-mm-dd',
        disableWeekends: true,
        showDaysInNextAndPreviousMonths: true,
        showClearBtn: true,
        onSelect() {},
      });
    },
    async fetchSecurityClasses() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/security_classes/`);
      this.securityClasses = data;
    },
    initModal() {
      this.usmTempModal = this.materialize.Modal.init(document.getElementById('add-rec-usm-temp-modal'), {
        preventScrolling: false,
        dismissible: false,
      });
    },
    async vet() {
      this.loading = true;
      if (this.selectedSecurityClass !== 6) { // Is not a crypto
        const { data } = await axios.put(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/vet/`, {
          analyst_id: this.$auth.user.pk,
          instrument_id: this.payload.instrument_id,
          security_class_id: this.selectedSecurityClass,
        });
      }
      await this.handleInstrumentPick(`#${this.payload.instrument_id} `);
      this.loading = false;
      this.usmTempModal.close();
    },
  },
  mounted() {
    this.fetchPortfolios();
    this.fetchSecurityClasses();
    this.fetchTeams();
    this.initDatepicker();
    this.initModal();
  },
};
</script>
